const themes = [
    { name: "Light", className: "light" },
    { name: "Light high contrast", className: "high-contrast-light" },
    { name: "Dark default", className: "dark" },
    { name: "Dark high contrast", className: "high-contrast-dark" },
    { name: "Dark dimmed", className: "dark-dimmed" },
  ];

export default themes;